<template>
    <div>
        <div class="level is-vcentered">
            <div class="level-left">
                <h1 class="title is-size-4">Weights</h1>
            </div>
            <div class="level-right">
                <router-link class="level-item button is-outlined" to="/Admin">Back to Admin</router-link>
            </div>
        </div>
        <h6 class="subtitle">Set the default weights to be used for all new projects</h6>

        <b-notification type="is-danger" v-if="errorMessage" :closable="false">
            {{ errorMessage }}
        </b-notification>

        <b-tabs>
            <template v-for="(axis, index) in groupedByAxis">
                <b-tab-item :label="axis.name" :key="index">
                    <weight-setting class="centered box" :axis-weights="axis" @save-event="saveAxis"></weight-setting>
                </b-tab-item>
            </template>
        </b-tabs>
    </div>
</template>

<script>
import DefaultMetricWeightService from '@/services/default-metric-weight-service';
import _ from 'lodash';
import WeightSetting from '@/components/WeightSetting.vue';
import CONSTANTS from '@/constants.js';

export default {
    name: 'WeightsAdmin',
    components: {
        WeightSetting: WeightSetting
    },
    data () {
        return {
            isLoading: true,
            errorMessage: '',
            metricWeights: [],
            pillarWeights: [],
            showTable: true
        };
    },
    async created () {
        try {
            this.metricWeights = (await DefaultMetricWeightService.getDefaultMetricWeights()).data;
            this.pillarWeights = (await DefaultMetricWeightService.getDefaultPillarWeights()).data;
        } catch (error) {
            this.errorMessage = error.message;
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        editAxis (axis) {
            axis.isEditing = true;
        },
        async saveAxis (savedAxis) {
            try {
                if (savedAxis.name === CONSTANTS.AXIS['P'].name) {
                    await DefaultMetricWeightService.updateDefaultPillarWeights(savedAxis.metrics);
                } else {
                    await DefaultMetricWeightService.updateDefaultMetricWeights(savedAxis.metrics);
                }
                this.$buefy.toast.open({
                    message: savedAxis.name + ' has been saved',
                    type: 'is-success'
                });
            } catch (error) {
                this.$buefy.toast.open({
                    message: error.message,
                    type: 'is-danger'
                });
            }
        }
    },
    computed: {
        groupedByAxis () {
            let combinedWeights = this.metricWeights.concat(this.pillarWeights);
            let g = _.groupBy(combinedWeights, metric => metric.axis);
            let axisNames = Object.keys(g);
            let result = axisNames.map(axisName => {
                return {
                    name: CONSTANTS.AXIS[axisName].name,
                    metrics: g[axisName]
                };
            });
            return result;
        }
    }
};
</script>

<style lang="scss">
.subtitle{
    margin-top:1rem;
    margin-bottom:1rem;
}
</style>
